
/* Conserto do carrinho para site estático (sem backend Shopify). Clicar na lixeira
   ZERA o carrinho inteiro (igual ao site real trysleepease.co), mostrando o estado
   vazio. Também cancela a chamada /cart/change.js que travava em loading infinito. */
(function(){
  "use strict";
  function parseMoney(t){
    if(t==null) return 0; var raw=String(t);
    if(/free/i.test(raw) && !/\d/.test(raw)) return 0;
    var m=(raw.match(/[\d.,]+/)||[])[0]; if(!m) return 0;
    if(m.indexOf(',')>-1 && m.indexOf('.')>-1){ m=m.replace(/,/g,''); }
    else if(m.indexOf(',')>-1 && /,\d{2}$/.test(m)){ m=m.replace(/\./g,'').replace(',', '.'); }
    else { m=m.replace(/,/g,''); }
    var v=parseFloat(m); return isNaN(v)?0:v;
  }
  function fmt(v){ return '$'+v.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2}); }
  function qtyOf(tr){ var q=tr.querySelector('input[type="number"], .quantity__input'); var n=q?parseInt(q.value,10):1; return (isNaN(n)||n<1)?1:n; }
  function finalOf(tr){
    var fp=tr.querySelector('.cart-item__final-price');
    if(fp){ var t=fp.textContent.trim(); return /free/i.test(t)?0:parseMoney(t); }
    var pd=tr.querySelector('.gb-price-drawer');
    if(pd){ var c=pd.cloneNode(true); c.querySelectorAll('s,.cart-item__old-price,[class*="saving"],[class*="save"]').forEach(function(e){e.remove();}); var x=c.textContent.trim(); return /free/i.test(x)?0:parseMoney(x); }
    return 0;
  }
  function oldOf(tr){ var s=tr.querySelector('.cart-item__old-price'); return s?parseMoney(s.textContent):null; }

  function showEmpty(){
    document.querySelectorAll('.cart-drawer form, #CartDrawer form, cart-drawer form, .drawer__inner form, .cart-items, cart-drawer-items, .totals, .gb-discounts-cart-values, .cart__footer, .drawer__footer, .cart__ctas, [name="checkout"]').forEach(function(e){ e.style.display='none'; });
    document.querySelectorAll('.cart-count-bubble').forEach(function(e){ e.style.display='none'; });
    document.querySelectorAll('.gb-cart-total-item').forEach(function(e){ e.textContent='0'; });
    var host=document.querySelector('.drawer__inner')||document.querySelector('#CartDrawer')||document.querySelector('cart-drawer')||document.body;
    if(host && !host.querySelector('.static-cart-empty')){
      var box=document.createElement('div');
      box.className='static-cart-empty';
      box.style.cssText='padding:56px 24px;text-align:center;';
      box.innerHTML='<h2 style="font-size:28px;font-weight:700;margin:0 0 28px;">Your cart is empty</h2>'
        +'<a href="/" style="display:inline-block;background:#1a63ee;color:#fff;text-decoration:none;padding:15px 30px;border-radius:8px;font-weight:600;font-size:16px;">Continue shopping</a>';
      host.appendChild(box);
    }
  }
  function recompute(){
    var lines=document.querySelectorAll('tr.cart-item');
    if(lines.length===0){ showEmpty(); return; }
    var count=0,total=0,comp=0;
    lines.forEach(function(tr){ var q=qtyOf(tr),f=finalOf(tr),o=oldOf(tr); count+=q; total+=f*q; comp+=((o!=null?o:f))*q; });
    var disc=comp-total;
    document.querySelectorAll('.totals__total-value').forEach(function(e){ e.textContent=fmt(total); });
    document.querySelectorAll('.gb-totals-total-value').forEach(function(e){ e.textContent=String(Math.round(total*100)); });
    document.querySelectorAll('.discount_price-container .cart-item__old-price').forEach(function(e){ e.textContent=fmt(comp); });
    document.querySelectorAll('.totals__subtotal-value').forEach(function(e){ e.textContent=fmt(comp); });
    document.querySelectorAll('.discount_discount-value').forEach(function(e){ var sp=e.querySelector('span:last-child')||e; sp.textContent='-'+fmt(disc>0?disc:0); });
    document.querySelectorAll('.gb-cart-total-item').forEach(function(e){ e.textContent=String(count); });
    document.querySelectorAll('.cart-count-bubble').forEach(function(e){ var a=e.querySelector('span[aria-hidden="true"]'); if(a) a.textContent=String(count); var v=e.querySelector('.visually-hidden'); if(v) v.textContent=count+' items'; });
    var w=document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null), re=/(Total:\s*)\d+(\s*Items?)/i, n;
    while((n=w.nextNode())){ if(re.test(n.nodeValue)) n.nodeValue=n.nodeValue.replace(re,'$1'+count+'$2'); }
  }

  // Lixeira -> ZERA o carrinho inteiro (igual ao site real)
  document.addEventListener('click', function(e){
    var btn=e.target.closest && e.target.closest('cart-remove-button, .cart-remove-button, [id^="CartDrawer-Remove"]');
    if(!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    document.querySelectorAll('tr.cart-item').forEach(function(tr){ tr.remove(); });
    showEmpty();
  }, true);

  // Quantidade: cancela o fetch travado e recalcula
  document.addEventListener('change', function(e){
    var inp=e.target.closest && e.target.closest('.quantity__input, input[type="number"]');
    if(!inp || !inp.closest('tr.cart-item, .cart-item, cart-drawer, #CartDrawer')) return;
    e.stopImmediatePropagation();
    recompute();
  }, true);
})();
